var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptodataLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 20.934,
    viewBox: "0 0 132 20.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_CD_orizontal",
    "data-name": "logo CD orizontal",
    transform: "translate(-6.1 -3.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1504.883,8.587a5.8,5.8,0,0,0-11.428,0H1490l9.107,16.108,9.23-16.108Z",
    transform: "translate(-1370.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(6.1 8.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M6.1,76.988V69.221Q6.1,67,8.873,67h8.51v1.57H9.432c-.49,0-.735.2-.735.59v7.882c0,.4.245.59.735.59H17.39V79.2H8.873C7.027,79.21,6.1,78.467,6.1,76.988Z",
    transform: "translate(-6.1 -67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M182.4,119.378v-6.809q0-2.068,2.589-2.068h3.148v1.386h-2.681c-.429,0-.651.176-.651.521v6.978l-2.405-.008Z",
    transform: "translate(-168.896 -107.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M269.3,110.4h2.428l3.217,6.572,3.217-6.572h2.42l-6.25,12.769h-2.421l1.815-3.738Z",
    transform: "translate(-249.14 -107.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M436,123.169V110.4h7.215q2.585,0,2.589,2.068V117.2c0,1.379-.866,2.076-2.589,2.076h-4.81v3.883H436Zm2.405-5.278h4.351c.429,0,.651-.176.651-.521V112.3c0-.345-.214-.521-.651-.521h-4.351Z",
    transform: "translate(-403.071 -107.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M595.4,77.134V67h2.405v3.332h3.332v1.386h-3.332V77.3c0,.345.214.521.651.521h2.681V79.21h-3.148C596.258,79.21,595.4,78.513,595.4,77.134Z",
    transform: "translate(-550.261 -67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M696.8,117.3v-4.734q0-2.068,2.589-2.068h4.626c1.731,0,2.589.689,2.589,2.068V117.3c0,1.379-.866,2.076-2.589,2.076h-4.626C697.665,119.378,696.8,118.681,696.8,117.3Zm2.405.169c0,.345.214.521.651.521h3.7c.429,0,.651-.176.651-.521V112.4c0-.345-.215-.521-.651-.521h-3.7c-.429,0-.651.176-.651.521Z",
    transform: "translate(-643.894 -107.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M858.6,79.21V67h6.289q5.917,0,5.921,4.734v2.735q0,4.734-5.921,4.734l-6.289.008Zm2.6-1.578h3.332q3.7,0,3.7-2.957V71.527q0-2.964-3.7-2.964H861.2Z",
    transform: "translate(-793.301 -67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1028.9,79.21,1034.637,67h2.964l5.737,12.21H1040.7l-1.425-3.049h-6.327l-1.425,3.049Zm4.795-4.626h4.849l-2.42-5.178Z",
    transform: "translate(-950.556 -67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1196.8,68.57V67h12.945v1.57h-5.178V79.21h-2.589V68.57Z",
    transform: "translate(-1105.596 -67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1345.3,79.21,1351.037,67H1354l6.779,12.21h-3.669l-1.425-3.049h-6.327l-1.425,3.049Zm4.795-4.626h4.849l-2.42-5.178Z",
    transform: "translate(-1242.721 -67)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptodataLogo);
export default __webpack_public_path__ + "static/media/cryptodata-logo.5529929512f805838959142a9643bb50.svg";
export { ForwardRef as ReactComponent };